// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1555 ? "6ab58981" : chunkId) + "." + {"92":"b9ada285d58a324a","1555":"16f5f7d855a668da","9289":"91fbee531b1cde20","9375":"f0732a78e86f7db7"}[chunkId] + ".js";
};